export default __webpack_public_path__ + "static/blob8-f38de56f8af2563c1992fd2c1026a5a0.svg";